import React, {useEffect, useRef} from "react";
import L from "leaflet";

export const DeliveryRequestMarker = ({mapInstance, markerData, onDragEnd, isVisible = true}) => {
    const markerRef = useRef(null);

    useEffect(() => {
        if (!mapInstance || !markerData || !isVisible) return;

        const isPickupPoint = markerData.color === "red";
        const isDeliveryPoint = markerData.color === "gray";

        // Create custom icon based on marker type
        const iconColor = markerData.color === "red" ? "#ff4444" : "#AEF001";
        const iconHtml = `
            <div style="
                width: 30px;
                height: 30px;
                background-color: ${iconColor};
                border: 3px solid white;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 2px 4px rgba(0,0,0,0.3);
                font-weight: bold;
                color: white;
                font-size: 12px;
            ">
                ${markerData.title}
            </div>
        `;

        const customIcon = L.divIcon({
            html: iconHtml,
            className: "delivery-request-marker",
            iconSize: [30, 30],
            iconAnchor: [15, 15],
            popupAnchor: [0, -15]
        });

        // Create marker
        const marker = L.marker([markerData.location.latitude, markerData.location.longitude], {
            icon: customIcon,
            draggable: isDeliveryPoint
        });

        // Add popup with title
        const title = isPickupPoint
            ? "Alış Noktası"
            : "Teslimat Noktası - Sürükleyerek Konumu Değiştirebilirsiniz";
        marker.bindPopup(title);

        // Add drag event listener for delivery points
        if (isDeliveryPoint && onDragEnd) {
            marker.on("dragend", async e => {
                const lat = e.target.getLatLng().lat;
                const lng = e.target.getLatLng().lng;
                await onDragEnd(lat, lng, markerData);
            });
        }

        marker.addTo(mapInstance);
        markerRef.current = marker;

        return () => {
            if (markerRef.current) {
                mapInstance.removeLayer(markerRef.current);
                markerRef.current = null;
            }
        };
    }, [mapInstance, markerData, onDragEnd, isVisible]);

    // Update marker position if markerData changes
    useEffect(() => {
        if (markerRef.current && markerData) {
            markerRef.current.setLatLng([
                markerData.location.latitude,
                markerData.location.longitude
            ]);
        }
    }, [markerData?.location?.latitude, markerData?.location?.longitude]);

    return null; // This component doesn't render anything directly
};
